import { TextField } from '@nexus/lib-react/dist/core/TextField/TextField';
import styled from '../../../../../../theme/styled';

const StyledTextField = styled(TextField)`
  box-sizing: border-box;
  height: 48px;
`;

const Wrapper = styled.div`
  label {
    padding-bottom: 6px;
  }
`;

export default {
  StyledTextField,
  Wrapper,
};
